import React from 'react';
import { Card } from 'react-bootstrap';

const WORK_STUDY = { yes: 'Yes', no: 'No', not_sure: 'Not sure' };

function Item({ label, children }) {
    return (
        <>
            <dt className="small text-muted fw-normal">{label}</dt>
            <dd className="mb-2">{children}</dd>
        </>
    );
}

function GeneralPoolCard({ application }) {
    const { generalPool, availability } = application;
    if (typeof generalPool !== 'boolean') return null;
    const slots = availability?.schedule || [];
    const hours = availability?.hoursPerWeek;
    return (
        <Card className="mb-3 border-0 shadow-sm">
            <Card.Header className="bg-light">
                <strong>General pool</strong>
            </Card.Header>
            <Card.Body>
                <p className="mb-0">
                    {generalPool
                        ? 'General pool: yes'
                        : 'General pool: no, selected positions only'}
                </p>
                {generalPool && (hours != null || slots.length > 0) && (
                    <dl className="mt-2 mb-0">
                        {hours != null && hours !== '' && (
                            <Item label="Hours available per week">
                                {hours}
                            </Item>
                        )}
                        {slots.length > 0 && (
                            <Item label="Weekly schedule">
                                <ul className="mb-0">
                                    {slots.map((slot, index) => (
                                        <li key={index}>
                                            {slot.day}: {slot.startTime} -{' '}
                                            {slot.endTime}
                                        </li>
                                    ))}
                                </ul>
                            </Item>
                        )}
                    </dl>
                )}
            </Card.Body>
        </Card>
    );
}

function CampusEmploymentCard({ application }) {
    const campusEmployment = application.campusEmployment;
    if (!campusEmployment?.workStudy) return null;
    const { workStudy, holdsCampusPosition, hoursPerWeek } = campusEmployment;
    return (
        <Card className="mb-3 border-0 shadow-sm">
            <Card.Header className="bg-light">
                <strong>Campus employment</strong>
            </Card.Header>
            <Card.Body>
                <dl className="mb-0">
                    <Item label="Awarded work-study funds">
                        {WORK_STUDY[workStudy] || workStudy}
                        <div className="small text-muted">
                            Self-reported, to be verified
                        </div>
                    </Item>
                    {typeof holdsCampusPosition === 'boolean' && (
                        <Item label="Holds a position on campus">
                            {holdsCampusPosition ? 'Yes' : 'No'}
                        </Item>
                    )}
                    {hoursPerWeek != null && hoursPerWeek !== '' && (
                        <Item label="Hours per week at those positions">
                            {hoursPerWeek}
                        </Item>
                    )}
                </dl>
            </Card.Body>
        </Card>
    );
}

/**
 * The general pool answer and the campus employment answers, read only.
 * Whoever is sent these answers reads them: the student, the program's
 * coordinators and a Learning Assistant's faculty (the server decides who is
 * sent what).
 */
function SharedAnswersSummary({ application }) {
    return (
        <>
            <GeneralPoolCard application={application} />
            <CampusEmploymentCard application={application} />
        </>
    );
}

export default SharedAnswersSummary;
